import {
  customTypesAccessLevelsAgainstProfile,
  ownProfileCustomTypesAccessLevels
} from "PFCore/helpers/custom_types";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { Profile } from "PFCore/types";
import { ActivityCustomField } from "PFTypes";
import { useMemo, useState } from "react";

type UseExperienceCustomFieldsParams = {
  initialCustomFields: ActivityCustomField[];
  adminPage: boolean;
  profile: Profile;
  currentProfile: Profile;
};

export const useExperienceCustomFields = ({
  initialCustomFields,
  adminPage,
  profile,
  currentProfile
}: UseExperienceCustomFieldsParams) => {
  const [customFields, setCustomFields] = useState(initialCustomFields);
  const { getPermittedTypes } = useCustomTypes();

  const permittedCustomTypes = useMemo(() => {
    const ctAccessLevels = adminPage
      ? customTypesAccessLevelsAgainstProfile(profile, currentProfile)
      : ownProfileCustomTypesAccessLevels(currentProfile);

    return getPermittedTypes({ ctAccessLevels });
  }, [adminPage, currentProfile, getPermittedTypes, profile]);

  const getCustomType = (name) => permittedCustomTypes.find((customType) => customType.name === name);

  const getCustomField = (name) => customFields.filter((customField) => customField.type.name === name)[0];

  const getCustomFieldValues = (name) => {
    const customField = getCustomField(name);
    return customField ? customField.values : [];
  };

  const updateCustomField = (customType, values) => {
    const newCustomFields = [...customFields];
    const customField = newCustomFields.find(({ type }) => type.name === customType.name);

    if (customField) {
      customField.values = values;
      setCustomFields(newCustomFields);
    } else {
      setCustomFields((prev) => [
        ...prev,
        {
          type: { id: customType.id, name: customType.name },
          values
        }
      ]);
    }
  };

  return {
    customFields,
    getCustomFieldValues,
    updateCustomField,
    brandsCustomType: getCustomType("brands"),
    sectorsCustomType: getCustomType("sectors"),
    skillsCustomType: getCustomType("skills")
  };
};
